import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { context } from 'bookingbug-core-js';

@Injectable({
  providedIn: 'root',
})
export class AdelanteService {
  private url = 'https://staging.bookinglab.co.uk';
  private path = '/';
  adelanteUrlPath =
    window.location.hostname.indexOf('staging') !== -1
      ? '/payment/'
      : '/payment/';

  constructor(private http: HttpClient) {}

  async preBasketInvoke(company, service, basket, serviceItems, descriptions, client, fundCode, amounts, authToken, data, detailGroupId, slot, extraDuration, journeyRoute, reference, parentCompanyId?) {
    let port = '';
    // '' is the default port for the scheme -- without it a plain https
    // page scored a stray ":" into the payment gateway URL.
    const ports: any = ['80', '443', ''];
    console.log('port', window.location.port);
    if (ports.indexOf(window.location.port) === -1) {
      port = `:${window.location.port}`;
    }

    let serviceItemString = '';
    for (const serviceItem of serviceItems) {
      serviceItemString = `${serviceItemString},${serviceItem.id}`;
    }

    console.log(`Journey route: ${journeyRoute}`);

    let returnUrl = '';
    if (journeyRoute == 'order_a_copy_certificate') {
      returnUrl = `${window.location.protocol}//${window.location.hostname}${port}/start/${journeyRoute}/verify/${company.id}/${basket.id}/${serviceItemString}`;
    } else {
      returnUrl = `${window.location.protocol}//${window.location.hostname}${port}${this.path}payment-verify/${company.id}/${basket.id}/${serviceItemString}`;
    }

    console.log(`journeyRoute: ${journeyRoute} Return URL: ${returnUrl}`);

    const body = {
      host: `${context.apiUrl}`,
      // company_id MUST be the PARENT company (e.g. 37003). child_company stays the location.
      company_id: parentCompanyId === undefined ? `${company.id}` : parentCompanyId,
      child_company: `${company.id}`,
      service_id: `${service.id}`,
      client_id: `${client.id}`,
      basket: `${basket.id}`,
      service_items: serviceItems,
      descriptions: descriptions,
      data: data,
      return_url: `${returnUrl}`,
      back_url: `${returnUrl}`,
      auth_token: `${authToken}`,
      detail_group: detailGroupId,
      slot: slot,
      extra_duration: extraDuration,
      journey_route: journeyRoute,
      reference: `${reference}`,
      add_account_details: false,
      displayableReference: `${reference}`
    }
    console.log(typeof fundCode, Array.isArray(fundCode));
    if (Array.isArray(amounts)) {
      body['additionalCharges'] = amounts;
      const primaryAmount = amounts.find(a => a.charge > 0 && a.reference) || amounts.find(a => a.reference);
      if (primaryAmount) {
        body['reference'] = primaryAmount.reference;
      }
    }
    else {
      body['amount'] = `${amounts}`;
    }
    if (Array.isArray(fundCode)) {
      body['fund_codes'] = fundCode;
    }
    else {
      body['fund_code'] = `${fundCode}`;
    }

    body.displayableReference = body.reference;

    const result: any = await this.http.post(`${this.url}${this.adelanteUrlPath}adelante/pre-basket`, body).toPromise();
    return { ...result, url: result?.response?.Link || result?.url };
  }

  async preBasketFind(companyId, basketId, serviceItemId) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      child_company: `${companyId}`,
      basket: `${basketId}`,
      service_item: `${serviceItemId}`,
    };
    return this.http.post(`${this.url}${this.adelanteUrlPath}adelante/pre-basket/find`, body).toPromise();
  }

  checkStatus(basket: string, serviceItem: string) {
    const body = {
      host: `${context.apiUrl}`,
      basket: basket,
      service_item: serviceItem,
    };
    return this.http.post(`${this.url}${this.adelanteUrlPath}adelante/pre-basket/status`, body);
  }

  async preBasketUpdate(companyId, basketId, serviceItemId, status, ref, data) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      child_company: `${companyId}`,
      basket: `${basketId}`,
      service_item: `${serviceItemId}`,
      ref: ref,
      status: `${status}`,
      data: data
    };
    return this.http.post(`${this.url}${this.adelanteUrlPath}adelante/pre-basket/update`, body).toPromise();
  }
}
